'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaults = require('lodash/defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _queryString = require('query-string');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var services = {
  facebook: function facebook(_ref) {
    var url = _ref.url;

    return 'http://www.facebook.com/sharer.php?' + (0, _queryString.stringify)({ u: url });
  },
  mail: function mail(_ref2) {
    var url = _ref2.url,
        title = _ref2.title;

    return 'mailto:?' + (0, _queryString.stringify)({ body: url, subject: title });
  },
  linkedin: function linkedin(_ref3) {
    var url = _ref3.url,
        title = _ref3.title;

    return 'https://www.linkedin.com/shareArticle?' + (0, _queryString.stringify)({
      mini: true,
      url: url,
      title: title
    });
  },
  messenger: function messenger(_ref4) {
    var url = _ref4.url;

    return 'fb-messenger://share?' + (0, _queryString.stringify)({ link: url });
  },
  pinterest: function pinterest(_ref5) {
    var url = _ref5.url,
        title = _ref5.title,
        image = _ref5.image;

    return 'http://pinterest.com/pin/create/button/?' + (0, _queryString.stringify)({
      url: url,
      media: image,
      description: title
    });
  },
  reddit: function reddit(_ref6) {
    var url = _ref6.url,
        title = _ref6.title;

    return 'http://www.reddit.com/submit?' + (0, _queryString.stringify)({ url: url, title: title });
  },
  sms: function sms(_ref7) {
    var url = _ref7.url;

    return 'sms:?&' + (0, _queryString.stringify)({ body: url });
  },
  twitter: function twitter(_ref8) {
    var url = _ref8.url,
        title = _ref8.title,
        hashtags = _ref8.hashtags;

    return 'https://twitter.com/share?' + (0, _queryString.stringify)({
      url: url,
      hashtags: hashtags,
      text: title
    });
  },
  whatsapp: function whatsapp(_ref9) {
    var url = _ref9.url,
        title = _ref9.title;

    return 'whatsapp://send?' + (0, _queryString.stringify)({ text: [title, url].join(' - ') });
  }
};

var popupShares = ['facebook', 'twitter', 'linkedin', 'pinterest', 'reddit'];

var toString = function toString(obj) {
  return (0, _map2.default)(obj, function (value, key) {
    return key + '=' + value;
  }).join(',');
};

var openPopup = function openPopup(url, config) {
  config = (0, _defaults2.default)(config || {}, { width: 640, height: 320 });

  var windowTop = window.screenTop ? window.screenTop : window.screenY;
  var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;

  config.top = windowTop + window.innerHeight / 2 - config.height / 2;
  config.left = windowLeft + window.innerWidth / 2 - config.width / 2;
  config = toString(config);

  window.open(url, 'shareWindow', config);
};

exports.default = function (options) {
  return function () {
    var imageUrl = document.head.querySelector('meta[property="og:image"]') && document.head.querySelector('meta[property="og:image"]').content;

    var caption = options.caption,
        hashtags = options.hashtags,
        _options$image = options.image,
        image = _options$image === undefined ? imageUrl : _options$image,
        _options$title = options.title,
        title = _options$title === undefined ? document.title : _options$title,
        type = options.type,
        _options$url = options.url,
        url = _options$url === undefined ? window.location.href : _options$url;


    var service = services[type];

    if (service) {
      var popupConfig = {
        toolbar: 0,
        status: 0,
        width: 640,
        height: 320
      };

      var shareUrl = service({
        url: url,
        title: title,
        hashtags: hashtags,
        caption: caption,
        image: image
      });

      console.log(shareUrl);

      return popupShares.indexOf(type) > -1 ? openPopup(shareUrl, popupConfig) : window.location.assign(shareUrl);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/button-share/openShareDialog.js
// module id = 878
// module chunks = 0